package org.matthewo

import emotion.react.Global
import emotion.react.css
import emotion.react.styles
import org.matthewo.styles.BACKGROUND_COLOR
import org.matthewo.styles.FONT
import org.matthewo.styles.FONT_COLOR
import react.FC
import react.dom.html.ReactHTML.div
import react.useState
import tanstack.react.router.Outlet
import web.cssom.*

val Root = FC("Root") {
    Global {
        styles {
            "html" {
                fontSize = min(100.pct, 2.5.vh, 2.5.vw)
                lineHeight = number(1.2)

                "*" {
                    fontFamily = string(FONT)
                }
            }

            "html, body, #app" {
                backgroundColor = BACKGROUND_COLOR
                color = FONT_COLOR

                width = 100.vw
                height = 100.vh

                margin = 0.px
                padding = 0.px

                overflow = Overflow.hidden
            }
        }
    }

    val headerState = useState<HeaderContent>(DefaultHeader())

    HeaderContext.Provider {
        value = headerState
        div {
            css {
                width = 100.pct
                height = 100.pct
                display = Display.flex
                flexDirection = FlexDirection.column
            }

            Header()

            div {
                css {
                    width = 100.pct
                    flexGrow = number(1.0)
                    margin = 0.px
                    padding = 0.px
                    overflow = Auto.auto
                    display = Display.flex
                    flexDirection = FlexDirection.column
                }

                Outlet()
            }
        }
    }
}
